module.exports = __webpack_public_path__ + "static/media/sel_12_254.5b381821.mp4";